<div class="upload-wrapper" *ngIf="!disabled">

  <div class="dropzone-mod" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
    <i class="material-icons upload-icon">cloud_upload</i>
    <p>Trascina qui i file</p>
  </div>

  <div class="all-buttons-row">

    <input type="file" #fileInput hidden (change)="uploadFile($event)" multiple>

    <button type="button" class="btn-mini-outline" (click)="startUpload('')">ALLEGATO</button>

    <button type="button" class="btn-mini-outline" *ngFor="let t of customDocTypes" (click)="startUpload(t)">
      Carica {{t}}
    </button>

    <button type="button" class="btn-filter" [class.active]="filter.length==1" (click)="setFilter(['img'])">
      Immagini
    </button>
    <button type="button" class="btn-filter" [class.active]="filter.length>1" (click)="setFilter(['oth','pdf'])">
      Documenti
    </button>

    <button type="button" class="btn-download" [disabled]="downloading" (click)="downloadAll()">
      Scarica tutto
    </button>

  </div>

</div>




<div class="card" style="margin-top: 1rem;">

  <div *ngIf="viewGallery">

    <div class="row" *ngIf="!uploader" style="margin-left: 0!important">

      <div class="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 bshadow growx"
        *ngFor="let a of filtered_source; index as i " [ngClass]="{ 'concordato' : isConcordato(a) }">



        <button *ngIf="!disabled" type="button" color="warn" mat-icon-button (click)="delete(a)"
          style="position:absolute; top:0; right:0;"><i class="material-icons">delete_forever</i></button>

        <a class="halfwidth" (click)="openFile(i)">
          <img [src]="isImage(a)" class="halfwidth gallery-img" [ngClass]="{ 'concordato' : isConcordato(a) }">
        </a>

        <div class="img-footer" (click)="openFile(i)" *ngIf="showLabel">
          {{ a.fileName }} - {{humanize(a.size)}}
        </div>

        <div class="img-footer" (click)="openFile(i)" *ngIf="showTag">
          {{ a.tag }}
        </div>

      </div>

    </div>

  </div>

  <div *ngIf="!viewGallery">

    <div class="row" *ngIf="!uploader" style="margin-left: 0!important">
      <div class="col-12">

        <table style="width:100%">

          <tr>
            <th>Anteprima</th>
            <th>Nome file</th>
            <th>Data</th>
            <th>Dimensione</th>
            <th></th>
          </tr>

          <tr *ngFor="let a of filtered_source; index as i " (click)="openFile(i)">
            <td style="width:32px"> <img [src]="isImage(a)" width=32> </td>
            <td>{{a.fileName}}</td>
            <td>{{a.creationDate|date}}</td>
            <td>{{a.size/1024/1024|number:'0.2-2'}} MB</td>
            <td style="width:32px"><button *ngIf="!disabled" type="button" color="warn" mat-icon-button
                (click)="delete(a)"><i class="material-icons">delete_forever</i></button></td>
          </tr>

        </table>
      </div>
    </div>
  </div>

</div>

<input type="file" id="file" #file (change)="uploadFile($event)" style="display: none;" [accept]="accepted" multiple>